// extracted by mini-css-extract-plugin
export default {"promo_path":"PromoPath_promo_path__Gi4pQ","promo_path_mobile":"PromoPath_promo_path_mobile__svXCM","grid":"PromoPath_grid__8Fg1j","grid__mobile":"PromoPath_grid__mobile__0lwln"};